"use client";

import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Block = {
  id: string;
  title: string;
  content: string;
  type: "normal" | "blockquote";
};
type ListItem = {
  id: number;
  blockId: string;
  text: string;
};
const blocks: Block[] = [{
  id: "overview",
  title: "Overview",
  content: "This project involved the completion of three bathrooms designed with detailed small-format tiles that required exceptional craftsmanship and precision installation.",
  type: "normal"
}, {
  id: "challenge",
  title: "The Challenge",
  content: "Small tiles demand a high level of accuracy and patience during installation, as even minor inconsistencies can affect the final visual outcome.",
  type: "normal"
}, {
  id: "approach",
  title: "Our Approach",
  content: "The bathrooms were completed using carefully selected small-format tiles arranged with meticulous attention to alignment, spacing, and finish. Every detail was executed to achieve a refined and balanced design.Small tiles demand a high level of accuracy and patience during installation, as even minor inconsistencies can affect the final visual outcome.",
  type: "normal"
}, {
  id: "result",
  title: "The Result",
  content: "The finished bathrooms present a sophisticated and elegant aesthetic, combining precise tile craftsmanship with modern functionality.",
  type: "normal"
}];
const approachList: ListItem[] = [{
  id: 1,
  blockId: "approach",
  text: "Comprehensive system audit and bottleneck identification."
}, {
  id: 2,
  blockId: "approach",
  text: "Phased migration strategy with zero planned downtime."
}, {
  id: 3,
  blockId: "approach",
  text: "Implementation of robust security protocols."
}];
function ContentBlock({
  block,
  index
}: {
  block: Block;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
        {block.title}
      </h2>

      {block.type === "blockquote" ? <blockquote className="border-l-4 border-border pl-6 py-2 my-8 italic font-sans text-lg md:text-xl text-foreground/90">
          <p className="leading-relaxed">{block.content}</p>
        </blockquote> : <p className="font-sans text-base md:text-lg text-foreground leading-relaxed mb-6">
          {block.content}
        </p>}

    </div>;
}
export default function MainContent() {
  return <section id="main-content" className="bg-background ![padding:40px_32px_96px_0px]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 px-6 md:px-8">
        {blocks.map((block, i) => <ContentBlock key={block.id} block={block} index={i} />)}

         <div className="mt-2 flex justify-start">
          <Link to="https://ksluxury.cloudtech.com.cy/projects/" className="btn-primary">
            Back to Projects
          </Link>
        </div>
      </div>


    
    </section>;
}